module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("me • rid • i • an")]), _vm._v(", "), _c('i', [_vm._v("n.")]), _vm._v(" [L. "), _c('i', [_vm._v("meridianus,")]), _vm._v(" pertaining to midday, or to the south, from "), _c('i', [_vm._v("meridies,")]), _vm._v(" midday, the south; "), _c('i', [_vm._v("medius,")]), _vm._v(" middle, and "), _c('i', [_vm._v("dies,")]), _vm._v(" day.]")]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('ol', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('li', [_vm._v("the highest apparent point reached by a heavenly body in its course.")]), _vm._v(" "), _c('li', [_vm._v("(a)the highest point of power, prosperity, splendor, etc.; zenith; apex; culmination; (b)the middle period of one’s life, regarded as the highest point of health, vigor, etc.; prime.")]), _vm._v(" "), _c('li', [_vm._v("noon. ["), _c('i', [_vm._v("Obs.")]), _vm._v("]")]), _vm._v(" "), _c('li', [_vm._v("in astronomy, an imaginary great circle of the celestial sphere passing through the poles of the heavens and the zenith and nadir of any given point, and cutting the equator at right angles.")]), _vm._v(" "), _c('li', [_vm._v("in geography, (a) a great circle of the earth passing through the geographical poles and any given point on the earth’s surface; (b) the half of such a circle between the poles; (c) any of the lines of longitude running north and south on a globe or map, representing such a circle or half-circle.")]), _vm._v(" "), _c('li', [_vm._v("(a) a place or situation with its own distinctive character; (b) distinctive character.")]), _vm._v(" "), _c('li', [_vm._v("a graduated ring of brass, in which a globe is suspended and revolves.")])]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('blockquote', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('span', [_c('i', [_vm._v("first meridian:")]), _vm._v(" see "), _c('i', [_vm._v("prime meridian")]), _vm._v(" under "), _c('i', [_vm._v("prime.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('span', [_c('i', [_vm._v("magnetic meridian:")]), _vm._v(" a carefully located meridian from which secondary or guide meridians may be constructed.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("me • rid i • an, "), _c('i', [_vm._v("a.")])])]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('ol', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('li', [_vm._v("of or at noon or, especially, of the position or power of the sun at noon.")]), _vm._v(" "), _c('li', [_vm._v("of or passing through the highest point in the daily course of any heavenly body.")]), _vm._v(" "), _c('li', [_vm._v("of or along a meridian.")]), _vm._v(" "), _c('li', [_vm._v("of or at the highest point of prosperity, splendor, power, etc.")]), _vm._v(" "), _c('li', [_vm._v("southern. [Rare.]")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b97279b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/6-part.vue
// module id = 81
// module chunks = 0